// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.title[data-v-66625d22]{ margin-bottom: 5px; font-size: 13px; font-weight: bold; padding: 0 0 0 8px;\n}\n.title span[data-v-66625d22] { color: var(--main-danger);\n}\n.title span.ok[data-v-66625d22] { color: var(--main-green);\n}\n.info[data-v-66625d22]{ padding: 4px 8px; color: var(--main-blue-3); margin-bottom: 5px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
